import axios from 'axios';
import { getEnvSettings } from '../../../../../../config/environmentSettings';
export const sendOwnership = (client_code, deposit_code, params) => {
    return axios
        .post(`/custody/${client_code}/deposits/${deposit_code}/ownership_verification`, params, {
        baseURL: getEnvSettings().apiUrl,
    });
};
